import { render, staticRenderFns } from "./HMTipButton.vue?vue&type=template&id=bca98bc2&"
import script from "./HMTipButton.vue?vue&type=script&lang=js&"
export * from "./HMTipButton.vue?vue&type=script&lang=js&"
import style0 from "./HMTipButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports